import { initSentry } from './components/sentry/sentry'

const Sentry = initSentry()

const sendError = (err, options = {}) => {
    Sentry.captureException(err, {
        extra: {
            options,
        },
    })
}

shared.sendError = sendError
